import React, { FC } from 'react';
import { RouteComponentProps, Switch, Redirect } from 'react-router-dom';
import { EVENT_BASE_PATH, GREETING_CARD_PATH, GREETING_CARD_SPECIAL_DAY_LIST_PATH } from '../../../constants';
import PruRoute from '../../../../../common/components/PruRoute';
import SpecialDayList from './List';
import { ModulePermissionProps } from '../../../../../common/module/types';
import SpecialDayDetailPage from './Create/SpecialDayDetailPage';
import ParamsProvider from 'src/app/common/components/ParamsProvider';

export const specialDayPath = `${EVENT_BASE_PATH}${GREETING_CARD_PATH}${GREETING_CARD_SPECIAL_DAY_LIST_PATH}`;

const SpecialDayPage: FC<RouteComponentProps & ModulePermissionProps> = ({
  enableRead,
  enableCreate,
  enableUpdate,
}) => {
  return (
    <Switch>
      <Redirect exact from={specialDayPath} to={`${specialDayPath}/list`} />
      <PruRoute
        exact
        path={`${specialDayPath}/list`}
        render={(props) => (
          <ParamsProvider {...props} acceptKeys={['name', 'status', 'toDate', 'fromDate']}>
            <SpecialDayList enableRead={enableRead} enableCreate={enableCreate} enableUpdate={enableUpdate} />
          </ParamsProvider>
        )}
      />
      <PruRoute exact path={`${specialDayPath}/create`} render={(props) => <SpecialDayDetailPage {...props} />} />
      <PruRoute exact path={`${specialDayPath}/:id`} render={(props) => <SpecialDayDetailPage {...props} />} />
    </Switch>
  );
};

export default SpecialDayPage;
